(function (root, factory) {
  if (typeof define === 'function' && define.amd)
    define(['exports', './kotlin-kotlin-stdlib.js'], factory);
  else if (typeof exports === 'object')
    factory(module.exports, require('./kotlin-kotlin-stdlib.js'));
  else {
    if (typeof this['kotlin-kotlin-stdlib'] === 'undefined') {
      throw new Error("Error loading module 'fixers-f2-f2-client-f2-client-ktor'. Its dependency 'kotlin-kotlin-stdlib' was not found. Please, check whether 'kotlin-kotlin-stdlib' is loaded prior to 'fixers-f2-f2-client-f2-client-ktor'.");
    }
    root['fixers-f2-f2-client-f2-client-ktor'] = factory(typeof this['fixers-f2-f2-client-f2-client-ktor'] === 'undefined' ? {} : this['fixers-f2-f2-client-f2-client-ktor'], this['kotlin-kotlin-stdlib']);
  }
}(this, function (_, kotlin_kotlin) {
  'use strict';
  //region block: imports
  var protoOf = kotlin_kotlin.$_$.fa;
  var classMeta = kotlin_kotlin.$_$.z8;
  var setMetadataFor = kotlin_kotlin.$_$.ga;
  var objectMeta = kotlin_kotlin.$_$.ea;
  var defineProp = kotlin_kotlin.$_$.b9;
  //endregion
  //region block: pre-declaration
  setMetadataFor(Protocol, 'Protocol', classMeta);
  setMetadataFor(HTTP, 'HTTP', objectMeta, Protocol);
  setMetadataFor(HTTPS, 'HTTPS', objectMeta, Protocol);
  setMetadataFor(WS, 'WS', objectMeta, Protocol);
  setMetadataFor(WSS, 'WSS', objectMeta, Protocol);
  setMetadataFor(TCP, 'TCP', objectMeta, Protocol);
  //endregion
  function Protocol() {
  }
  function HTTP() {
    HTTP_instance = this;
    Protocol.call(this);
  }
  var HTTP_instance;
  function HTTP_getInstance() {
    if (HTTP_instance == null)
      new HTTP();
    return HTTP_instance;
  }
  function HTTPS() {
    HTTPS_instance = this;
    Protocol.call(this);
  }
  var HTTPS_instance;
  function HTTPS_getInstance() {
    if (HTTPS_instance == null)
      new HTTPS();
    return HTTPS_instance;
  }
  function WS() {
    WS_instance = this;
    Protocol.call(this);
  }
  var WS_instance;
  function WS_getInstance() {
    if (WS_instance == null)
      new WS();
    return WS_instance;
  }
  function WSS() {
    WSS_instance = this;
    Protocol.call(this);
  }
  var WSS_instance;
  function WSS_getInstance() {
    if (WSS_instance == null)
      new WSS();
    return WSS_instance;
  }
  function TCP() {
    TCP_instance = this;
    Protocol.call(this);
  }
  var TCP_instance;
  function TCP_getInstance() {
    if (TCP_instance == null)
      new TCP();
    return TCP_instance;
  }
  //region block: exports
  function $jsExportAll$(_) {
    var $f2 = _.f2 || (_.f2 = {});
    var $f2$client = $f2.client || ($f2.client = {});
    var $f2$client$ktor = $f2$client.ktor || ($f2$client.ktor = {});
    $f2$client$ktor.Protocol = Protocol;
    defineProp($f2$client$ktor, 'HTTP', HTTP_getInstance);
    defineProp($f2$client$ktor, 'HTTPS', HTTPS_getInstance);
    defineProp($f2$client$ktor, 'WS', WS_getInstance);
    defineProp($f2$client$ktor, 'WSS', WSS_getInstance);
    defineProp($f2$client$ktor, 'TCP', TCP_getInstance);
  }
  $jsExportAll$(_);
  _.$jsExportAll$ = $jsExportAll$;
  //endregion
  return _;
}));

//# sourceMappingURL=fixers-f2-f2-client-f2-client-ktor.js.map
